import { render } from "./Register.vue?vue&type=template&id=e96bc13e&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=e96bc13e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e96bc13e"],['__file',"src/views/site/Register.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e96bc13e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e96bc13e', __exports__)) {
    api.reload('e96bc13e', __exports__)
  }
  
  module.hot.accept("./Register.vue?vue&type=template&id=e96bc13e&scoped=true", () => {
    api.rerender('e96bc13e', render)
  })

}


export default __exports__